import apiBaseUrl from '../../utils/config.js';

class PromotionService {
  constructor() {
    this.baseUrl = `${apiBaseUrl}/promotions`;
  }

  getToken() {
    return localStorage.getItem('jwt');
  }

  getAuthHeaders() {
    const token = this.getToken();
    return {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    };
  }

  async #request(endpoint = '', method = 'GET', body = null, parseAs = 'json') {
    const url = `${this.baseUrl}${endpoint}`;
    const options = {
      method,
      headers: this.getAuthHeaders(),
      credentials: 'include', // Include cookies in cross-origin requests
    };

    if (body) {
      options.body = JSON.stringify(body);
    }

    try {
      const response = await fetch(url, options);
      if (!response.ok) {
        const error = await response.text();
        throw new Error(error || `HTTP ${response.status}`);
      }

      if (parseAs === 'text') return await response.text();
      if (parseAs === 'json-text') {
        const text = await response.text();
        return text ? JSON.parse(text) : [];
      }

      return await response.json();
    } catch (error) {
      console.error(`Error in ${method} ${url}:`, error);
      throw error;
    }
  }

  async getAll() {
    return this.#request('/all', 'GET', null, 'json-text');
  }

  async getById(id) {
    return this.#request(`/${id}`);
  }

  async add(promotion) {
    return this.#request('/add', 'POST', promotion);
  }

  async update(id, promotion) {
    return this.#request(`/${id}`, 'PUT', promotion);
  }

  async updateStatus(id, status) {
    return this.#request(`/${id}/status?status=${status}`, 'PUT');
  }

  async delete(id) {
    return this.#request(`/${id}`, 'DELETE', null, 'text');
  }

  async getSorted() {
    return this.#request('/sorted');
  }
}

export default PromotionService;
